import React from 'react';
import { motion } from 'framer-motion';
import Form from '../Form/form';

const Auto = () => {
    return (
        <motion.div
            initial={{ opacity: 1 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8 }}
            className="h-auto bg-primary flex justify-center items-center h-max-screen"
        >
            <motion.div
                initial={{ x: 100, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.8, delay: 0.2 }}
                className="h-full w-full px-4 sm:px-9 pt-6 sm:pt-9 flex flex-col sm:flex-row justify-between items-center"
            >
                {/* Left Section */}
                <motion.div
                    initial={{ y: 50, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.8, delay: 0.4 }}
                    className="flex-1 pl-4 sm:pl-10 lg:pl-28 flex flex-col justify-center items-start gap-4 sm:gap-6"
                >
                    {/* Tagline */}
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.4, delay: 0.6 }}
                        className="text-secondary sm:text-lg lg:text-2xl font-medium font-nunito-sans text-center sm:text-left"
                    >
                        <span className="font-bold">Lumi Glass</span> <span>Partnered with Bob's Glass Works</span>
                    </motion.div>
                    {/* Title */}
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.4, delay: 0.7 }}
                        className="text-secondary text-2xl sm:text-4xl lg:text-6xl font-extrabold font-['Playfair_Display'] text-center sm:text-left leading-tight"
                    >
                        Premium Automotive Glass Repair Services
                    </motion.div>
                    {/* Description */}
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.4, delay: 0.8 }}
                        className="text-secondary text-sm lg:text-lg font-light font-nunito-sans text-center sm:text-left leading-relaxed"
                    >
                        At <span className="font-semibold">The Lumi Glass</span>, we deliver top-notch automotive glass repair and replacement services. Whether it's a cracked windshield or custom glass solutions, we ensure precision, durability, and care to keep you safe on the road.
                    </motion.div>
                </motion.div>
                {/* Right Section */}
                <motion.div
                    initial={{ x: -100, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    transition={{ duration: 0.8, delay: 0.5 }}
                    className="h-full flex-1 md:pt-56 sm:pt-0 w-full sm:w-auto mt-6 sm:mt-0 flex justify-center sm:justify-end items-center px-4 sm:px-10 lg:px-56 "
                >
                    <Form />
                </motion.div>
            </motion.div>
        </motion.div>
    );
};

export default Auto;
